import SwivuSettingsTagValueTabBase from "./SwivuSettingsTagValueTabBase.jsx";
import { TAGS_KEYS } from "../../../other/constants/TagsKeys.jsx";
import { STORE_KEYS } from "../../../other/constants/StoreKeys.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";

const GRID_KEYS = {
  categoryGrid: "clientCategoriesGrid"
};

export default class SwivuSettingsClientCategoryTab extends SwivuSettingsTagValueTabBase {
  static get $name() {
    return "SwivuSettingsClientCategoryTab";
  }

  static get type() {
    return "swivusettingsclientcategorytab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.clientCategoryTab;
  }

  getStoreName() {
    return STORE_KEYS.clientTagValuesStore;
  }

  getTagKeysWithWidgetRef() {
    return {
      [TAGS_KEYS.category]: GRID_KEYS.categoryGrid,
    };
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap[GRID_KEYS.categoryGrid];
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  static get configurable() {
    return {
      title: "Clients",
      ...SwivuSettingsTagValueTabBase.getDefaultLayoutSettings(),
      items: {
        [GRID_KEYS.categoryGrid]: SwivuSettingsTagValueTabBase.getGridWidget({
          headerText: "Client Categories",
          defaultValue: "Enter Category"
        }),
      }
    };
  }
}

SwivuSettingsClientCategoryTab.initClass();
